// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17auM","type":"styles_type__3y1xt","choices":"styles_choices__2RlVw"};